import FDBFactory from "./FDBFactory.js";
const fakeIndexedDB = new FDBFactory();
export default fakeIndexedDB;